import * as actions from './playlistActions'

const playlistInit = {}
export default (state = playlistInit, action) => {
	switch (action.type) {
		case actions.GET_PLAYLIST_SUCCESS:
			if (action.playlist) {
				const playlist = action.playlist
				return {
					id: playlist.id,
					name: playlist.name,
					image_rectangle: playlist.image_rectangle,
					images: playlist.images300,
					backgroundImage: playlist.images300 && playlist.images300.length ? playlist.images300[0] : undefined,
					tracksCount: playlist.tracks_count,
					duration: playlist.duration,
					description: playlist.description,
					owner: playlist.owner ? playlist.owner.name : '',
					genres: (playlist.genres || []).map(genre => genre.name)
				}
			}
			return playlistInit
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/pages/playlist/playlistReducers.js